// @ts-ignore
import BitcoinEsploraBatchApiProvider from '@liquality/bitcoin-esplora-batch-api-provider';
import Client from '@liquality/client';
import config from '../config/config';

export class BitcoinBatch {
  public client: typeof Client;

  constructor() {
    const bitcoin = new Client();

    bitcoin.addProvider(
      new BitcoinEsploraBatchApiProvider(config.bitcoin.batchApi, config.bitcoin.api)
    );

    this.client = bitcoin;
  }
}

export const client = new BitcoinBatch();
